import styled from 'styled-components';

const Section = styled.section`
	width: 500px;
	padding: 20px 25px;
	border-top: solid 4px var(--color-highlight);
	background-color: var(--color-main);
	box-shadow: 0px 2px 50px rgb(0, 0, 0, 0.5);
`;

export default Section;
